import { useLDClient } from 'launchdarkly-react-client-sdk';
import { NEW_DOWNLOAD_DRAWERS_FLAG } from '@/utils/constants';

/**
 * Returns `true` when the new download drawers are enabled.
 * Content performance uses the scoped export; the audience page opens the reports drawer.
 */
const useNewDownloadDrawersEnabled = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation(NEW_DOWNLOAD_DRAWERS_FLAG, false) ?? false;
};

export default useNewDownloadDrawersEnabled;
